module.exports = __webpack_public_path__ + "img/card_image_visa.5b03403.svg";